import React from "react"
import styled from "styled-components"
import ReactPlayer from "react-player"
import { buttonShadow } from "../../../../utils/shadows"
import HomepageHeroThumb from "../../../../images/homepage-hero-video-thumb.jpg"

const HomepageHeroVideo = () => (
  <PlayerWrapper>
    <StyledPlayer
      url="https://vimeo.com/348087822/e6053f2896"
      loop
      playing
      controls="false"
      muted
      width="100%"
      height="100%"
      className="react-player"
      light={HomepageHeroThumb}
    />
  </PlayerWrapper>
)

export default HomepageHeroVideo

const PlayerWrapper = styled.div`
  position: relative;
  padding-top: 56.25%;
  ${buttonShadow()}

  .react-player {
    position: absolute;
    top: 0;
    left: 0;
  }
`

const StyledPlayer = styled(ReactPlayer)`
  iframe {
    margin-bottom: 0;
  }
`
